import React from 'react'
import styled from 'styled-components'

const Row = ({ className, children }) => (
  <div className={className}>
    {children}
  </div>
)

export default styled(Row)`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 100%;
  height: fit-content;
  margin: 12px 0;
  
  :first-child {
    margin-top: 0;
  }
  
  :last-child {
    margin-bottom: 0;
  }
`
